export function advanceReturnReducer(state = "" ,{
    type,
    payload
}){
    
    switch(type){
        case "NEW_ADVANCE_RETURN":            
        case "UPDATE_ADVANCE_RETURN":
            let list = Object.assign({}, state);
            list[payload.advance_id] = payload
        
            return list
            
        case "GET_ADVANCE_RETURNS":
            return payload
            
        case "DELETE_ADVANCE_RETURN":
            let list2 = Object.assign({}, state);
            
            delete list2[payload]
            return list2
        default:
            return state;
    }
    
}